import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=01921a4c&scoped=true"
import script from "./Insights.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Insights.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./Insights.vue?vue&type=style&index=0&id=01921a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01921a4c",
  null
  
)

export default component.exports